import actionTypes from '../constants/action-types';

const pageTemplates = (state = [], action) => {
  switch (action.type) {
    case actionTypes.SET_PAGE_TEMPLATES: {
      return action.payload.pageTemplates;
    }
    default: {
      return state;
    }
  }
};

export default pageTemplates;
